import React from 'react';
import { includes, some } from 'lodash';
import ReactPlayer from 'react-player';
import noImage from '../../assets/images/no-image.png';

function ImageVideoSelector({ data, isDisabled, handleImageUpload, handleImageDelete, t, isDeleteBtn, isUploadBtn, isFromLink, isVideoType }) {
  const setVideo = (video) => {
    const words = ['/dam/', '/dam_folder/'];
    let videoPath = '';
    if (video?.includes('data:video/')) {
      videoPath = video;
    } else if (video?.includes('https')) {
      videoPath = video;
    } else if (some(words, (word) => includes(video, word))) {
      videoPath = `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${video}`;
    } else if (video?.includes('https://') || video?.includes('http://')) {
      videoPath = video;
    } else {
      videoPath = noImage;
    }
    return videoPath;
  };

  const setFileUrl = (fileUrl) => {
    const words = ['/dam/', '/dam_folder/'];
    let path = '';
    if (fileUrl?.includes('data:image/')) {
      path = fileUrl;
    } else if (fileUrl?.includes('data:video/')) {
      path = fileUrl;
    } else if (fileUrl?.includes('https')) {
      path = fileUrl;
    } else if (some(words, (word) => includes(fileUrl, word))) {
      path = `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${fileUrl}`;
    } else if (fileUrl?.includes('https://') || fileUrl?.includes('http://')) {
      path = fileUrl;
    } else {
      path = noImage;
    }
    return path;
  };
  return (
    <div className="image-container mr-3">
      {isVideoType ? (
        <div className="img">
          {data?.video ? (
            <ReactPlayer light={data?.thumbnailImage} className="react-player" url={setVideo(data?.video)} width="100%" height={150} controls />
          ) : (
            <img width="88" src={setFileUrl(data?.image) || noImage} alt="croppedImage" />
          )}
        </div>
      ) : (
        <div className="img">
          <img width="88" src={setFileUrl(data?.image) || noImage} alt="croppedImage" />
        </div>
      )}
      {!isDisabled && (
        <div className="d-flex flex-column">
          {isUploadBtn && (
            <button className="btn btn-upload-img" onClick={() => handleImageUpload()} type="button" aria-label={t('SPEC_TEMP_LIBRARY.UPLOAD_IMAGE')}>
              <span className="icon-upload" aria-hidden="true" />
            </button>
          )}
          {isDeleteBtn && (
            <button className="btn btn-upload-img" onClick={() => handleImageDelete()} type="button" aria-label={t('SPEC_TEMP_LIBRARY.REMOVE_IMAGE')}>
              <span className="icon-delete" aria-hidden="true" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default ImageVideoSelector;
